/** 通用占位页：S04 只保证导航通，内容在后续 Step 替换。 */

import { Typography } from "antd";
import { useParams } from "react-router-dom";

export function PlaceholderPage({ title, hint }: { title: string; hint?: string }) {
  return (
    <div style={{ padding: 48, textAlign: "center" }}>
      <Typography.Title level={3}>{title}</Typography.Title>
      <Typography.Paragraph type="secondary">
        {hint ?? "本模块将在后续 Step 中实现（见 docs/wiki/wiki.md）"}
      </Typography.Paragraph>
    </div>
  );
}

export function AssetsPage() {
  const { pid } = useParams();
  return <PlaceholderPage title="资产中心" hint={`项目 ${pid} 的环境/本体/任务资产（S06 落地）`} />;
}
